/**
 *
 * @param frameId
 * @param params
 *
 * params = {
 * titulo: 'Titulo da pagina',
 * ...params
 * }
 */

const origin = 'omnichannel'

export const emmitTrocarPagina = (frameId, params) => {
  let data = {
    origin,
    client: frameId,
    type: 'command',
    command: 'TROCA_PAGINA',
    data: {
      titulo: params.titulo,
      ...params
    },
    timestamp: Date.now()
  }

  window.parent.postMessage(data, '*')
}

export const emitNewPrescription = (frameId, data) => {
  const payload = {
    uid: window.omnisdkmanager ? window.omnisdkmanager.uid : '',
    origin,
    client: frameId,
    type: 'command',
    command: 'NOVA_PRESCRICAO',
    data,
    timestamp: Date.now()
  }

  window.parent.postMessage(payload, '*')
}
